import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderDetailsRoutingModule } from './order-details-routing.module';
import { OrderDetailsParentComponent } from './order-details-parent/order-details-parent.component';
import { IndividualOrderComponent } from './individual-order/individual-order.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { ViewOrderComponent } from './view-order/view-order.component';
import { BulkOrdersComponent } from './bulk-orders/bulk-orders.component';
import { OrdersListingComponent } from './orders-listing/orders-listing.component';
import { SelectModule } from 'primeng/select';
import { AutomatedBulkOrderComponent } from './automated-bulk-order/automated-bulk-order.component';
import { BulkOrderDetailComponent } from './automated-bulk-order/bulk-order-detail/bulk-order-detail.component';

@NgModule({
  declarations: [
    OrderDetailsParentComponent,
    IndividualOrderComponent,
    ViewOrderComponent,
    BulkOrdersComponent,
    OrdersListingComponent,
    AutomatedBulkOrderComponent,
    BulkOrderDetailComponent
  ],
  imports: [
    CommonModule,
    OrderDetailsRoutingModule,
    SelectModule,
    SharedComponentsModule
  ],
  exports: [ViewOrderComponent]
})
export class OrderDetailsModule {}
